import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import {
  IAddApprovalUser,
  IAddBannedItem,
  IAddFileCompression,
  IAddInventoryItemStatus,
  IAddNominationParty,
  IAddPartyNominationType,
  IAddPaymentType,
  IAddShad,
  IAddStorageSlab,
  IAddTaxType,
  IAddTerminal,
  IAddWarehouse,
  IAddYard,
  IAddYardRow,
  IPaymentAgent,
} from "src/common/typings/configuration";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

//Terminal
export const addNewTerminal = createAsyncThunk(
  "configuration/addNewTerminal",
  async (formRecord: IAddTerminal) => {
    try {
      const res = await ax.post<IApi>("/create_terminal", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateTerminal = createAsyncThunk(
  "configuration/updateTerminal",
  async (formRecord: IAddTerminal) => {
    try {
      const res = await ax.put<IApi>("/Update_terminal", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getTerminal = createAsyncThunk(
  "configuration/getTerminal", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("terminals_get_all");
      if (res.data.isSuccess === true && res.data.value.terminals) return res.data.value.terminals;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
//----------------------------------------------------------------------------------------------
export const addNewApprovalUser = createAsyncThunk(
  "configuration/addNewApprovalUser",
  async (formRecord: IAddApprovalUser) => {
    try {
      const res = await ax.post<IApi>("/approval_user_insert", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateApprovalUser = createAsyncThunk(
  "configuration/updateApprovalUser",
  async (formRecord: IAddApprovalUser) => {
    try {
      const res = await ax.put<IApi>("/approval_user_update", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getActiveApprovalUsers = createAsyncThunk(
  "configuration/getActiveApprovalUsers", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("get_all_active_approval_users");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllApprovalUser = createAsyncThunk(
  "configuration/getAllApprovalUser", // action string
  async (params: boolean) => {
    try {
      const res = await ax.get<IApi>(`get_all_approval_users?getActiveUsers=${params}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllYardAction = createAsyncThunk(
  "configuration/getAllYardAction", // action string
  async (isContainerYard: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-yards?IsContainerYard=${isContainerYard}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const gatAllYardRowAction = createAsyncThunk(
  "configuration/gatAllYardRowAction", // action string
  async (isContainerYard: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-yard-rows?IsContainerYard=${isContainerYard}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewYard = createAsyncThunk(
  "configuration/addNewYard",
  async (formRecord: IAddYard) => {
    try {
      formRecord = { ...formRecord, isContainerYard: formRecord?.isContainerYard || false };
      const res = await ax.post<IApi>("/create-yard", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateYard = createAsyncThunk(
  "configuration/updateYard",
  async (formRecord: IAddYard) => {
    try {
      formRecord = { ...formRecord, isContainerYard: formRecord?.isContainerYard || false };
      const res = await ax.put<IApi>("/update-yard", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewYardRow = createAsyncThunk(
  "configuration/addNewYardRow",
  async (formRecord: IAddYardRow) => {
    try {
      formRecord = { ...formRecord, isContainerYard: formRecord?.isContainerYard || false };
      const res = await ax.post<IApi>("/create-yard-row", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateYardRow = createAsyncThunk(
  "configuration/updateYardRow",
  async (formRecord: IAddYardRow) => {
    try {
      formRecord = { ...formRecord, isContainerYard: formRecord?.isContainerYard || false };
      const res = await ax.put<IApi>("/update-yard-row", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllPartName = createAsyncThunk(
  "configuration/getAllPartName", // action string
  async (parms: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-nomination-parties?getAllPartName=${parms}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getStorageSlabByType = createAsyncThunk(
  "configuration/getStorageSlabByType",
  async ({ type, isActive }: { type: string; isActive: boolean }) => {
    try {
      const res = await ax.get<IApi>(
        `/get-storage-slabs_by_type?Type=${type}&IsActive=${isActive}`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllStorageSlab = createAsyncThunk(
  "configuration/getAllStorageSlab", // action string
  async (parms: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-storage-slabs?getAllStorageSlab=${parms}`);
      if (res.data.isSuccess === true && res.data.value.slabsList) return res.data.value.slabsList;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addStorageSlab = createAsyncThunk(
  "configuration/addStorageSlab",
  async (formRecord: IAddStorageSlab) => {
    try {
      const res = await ax.post<IApi>("/create-storage_slab", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateStorageSlab = createAsyncThunk(
  "configuration/updateStorageSlab",
  async (formRecord: IAddStorageSlab) => {
    try {
      const res = await ax.put<IApi>("/update-storage_slab", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

////////////// Agent
export const getAllAgents = createAsyncThunk(
  "configuration/getAllAgents", // action string
  async (parms: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-agents?isActive=${parms}`);
      if (res.data.isSuccess === true && res.data.value.agents) return res.data.value.agents;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addAgent = createAsyncThunk(
  "configuration/addAgent",
  async (formRecord: IPaymentAgent) => {
    try {
      const res = await ax.post<IApi>("/create-agent", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateAgent = createAsyncThunk(
  "configuration/updateAgent",
  async (formRecord: IPaymentAgent) => {
    try {
      const res = await ax.put<IApi>("/update-agent", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

//////////////////////////////

export const addPartyName = createAsyncThunk(
  "configuration/addPartyName",
  async (formRecord: IAddNominationParty) => {
    try {
      const res = await ax.post<IApi>("/create-nomination-party", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updatePartyName = createAsyncThunk(
  "configuration/updatePartyName",
  async (formRecord: IAddNominationParty) => {
    try {
      const res = await ax.put<IApi>("/update-nomination-party", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const addPartyNominationType = createAsyncThunk(
  "configuration/addPartyNominationType",
  async (formRecord: IAddPartyNominationType) => {
    try {
      const res = await ax.post<IApi>("/create-party-nomination-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updatePartyNominationType = createAsyncThunk(
  "configuration/updatePartyNominationType",
  async (formRecord: IAddPartyNominationType) => {
    try {
      const res = await ax.put<IApi>("/update-party-nomination-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllPartyNominationType = createAsyncThunk(
  "configuration/getAllPartyNominationType", // action string
  async (parm: boolean) => {
    try {
      const res = await ax.get(`/get-all-party-nomination-types?getAllPartyNominationType=${parm}`);
      if (res.data?.isSuccess === true && res.data?.value) return res.data?.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllPaymentTypes = createAsyncThunk(
  "configuration/getAllPaymentTypes", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-payment-type");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const addNewPaymentType = createAsyncThunk(
  "configuration/addNewPaymentType",
  async (formRecord: IAddPaymentType) => {
    try {
      const res = await ax.post<IApi>("/create-payment-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updatePaymentTypeRow = createAsyncThunk(
  "configuration/updatePaymentTypeRow",
  async (formRecord: IAddPaymentType) => {
    try {
      const res = await ax.put<IApi>("/update-payment-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewTaxType = createAsyncThunk(
  "configuration/addNewTaxType",
  async (formRecord: IAddTaxType) => {
    try {
      const res = await ax.post<IApi>("/create-tax-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateTaxTypeRow = createAsyncThunk(
  "configuration/updateTaxTypeRow",
  async (formRecord: IAddTaxType) => {
    try {
      const res = await ax.put<IApi>("/update-tax-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllTaxTypes = createAsyncThunk(
  "configuration/getAllTaxTypes", // action string
  async (reqType: number) => {
    try {
      const res = await ax.get<IApi>(`get-all-tax-type/${reqType}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllWarehouses = createAsyncThunk(
  "configuration/getAllWarehouses", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-warehouse");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewWarehouse = createAsyncThunk(
  "configuration/addNewWarehouse",
  async (formRecord: IAddWarehouse) => {
    try {
      const res = await ax.post<IApi>("/create-warehouse", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewShed = createAsyncThunk(
  "configuration/addNewShed",
  async (formRecord: IAddShad) => {
    try {
      const res = await ax.post<IApi>("/create-shed-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const updateShad = createAsyncThunk(
  "configuration/updateShad",
  async (formRecord: IAddShad) => {
    try {
      const res = await ax.put<IApi>("/update-shed-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllShads = createAsyncThunk(
  "configuration/getAllShads", // action string
  async (getActiveSheds: boolean) => {
    try {
      const res = await ax.get<IApi>(`/get-all-shed-types?getActiveSheds=${getActiveSheds}`);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const updateWarehouse = createAsyncThunk(
  "configuration/updateWarehouse",
  async (formRecord: IAddWarehouse) => {
    try {
      const res = await ax.put<IApi>("/update-warehouse", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllInventoryItemStatuses = createAsyncThunk(
  "configuration/getAllInventoryItemStatuses", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-inventory-status-configuration");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewInventoryItemStatus = createAsyncThunk(
  "configuration/addNewInventoryItemStatus",
  async (formRecord: IAddInventoryItemStatus) => {
    try {
      const res = await ax.post<IApi>("/create-inventory-status", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateInventoryItemStatus = createAsyncThunk(
  "configuration/updateInventoryItemStatus",
  async (formRecord: IAddInventoryItemStatus) => {
    try {
      const res = await ax.put<IApi>("/update-inventory-status", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllFileCompressionConfigs = createAsyncThunk(
  "configuration/getAllFileCompressionConfigs", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-file-compression-config");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addUpdateFileCompressionConfig = createAsyncThunk(
  "configuration/addUpdateFileCompressionConfig",
  async (formRecord: IAddFileCompression) => {
    try {
      const res = await ax.post<IApi>("/create-or-update-file-compression-config", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getAllBannedItems = createAsyncThunk(
  "configuration/getAllBannedItems", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-banned-item");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addNewBannedItem = createAsyncThunk(
  "configuration/addNewBannedItem",
  async (formRecord: IAddBannedItem) => {
    try {
      const res = await ax.post<IApi>("/create-cargo-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateBannedItem = createAsyncThunk(
  "configuration/updateBannedItem",
  async (formRecord: IAddBannedItem) => {
    try {
      const res = await ax.put<IApi>("/update-cargo-type", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
